
  <a href="# ">
      <div class="service-item bg-secondary rounded border border-secondary">
          <img [src]="'../../../assets/' + promotion?.imageUrl" class="img-fluid rounded-top w-100" alt="">
          <div class="px-4 rounded-bottom">
              <div class="service-content bg-primary text-center p-4 rounded">
                  <h5 class="text-white">{{promotion?.name}}</h5>
                  <h3 class="mb-0">{{promotion?.promotion}}</h3>
              </div>
          </div>
      </div>
  </a>
